import { COD_CRISIS, COD_COMUNICATE, COD_APRENDER, COD_SOCIOEMOCIONAL } from '../../../helper';

const obtenerValor = (obj) => {
    if (!obj) return '';
    return typeof obj === 'object' && obj.valor !== undefined ? obj.valor : obj;
};

export const validarDatosFormulario = (tipoFormulario, state) => {
    const errores = [];

    // Validaciones generales
    // if (!obtenerValor(state?.documento_id)) errores.push('Número de identificación requerido');
    // if (!obtenerValor(state?.nombre_completo)) errores.push('Nombre del estudiante requerido');
    // if (!obtenerValor(state?.programa)) errores.push('Programa requerido');

    // Validaciones específicas por tipo
    // if (tipoFormulario === COD_CRISIS || tipoFormulario === 'ficha_unica') {
    //     if (!obtenerValor(state?.nivel_riesgo)) errores.push('Nivel de riesgo requerido');
    //     if (!obtenerValor(state?.descripcion_crisis)) errores.push('Descripción de la crisis requerida');
    //     if (!obtenerValor(state?.motivo_crisis)) errores.push('Motivo de la crisis requerido');
    //     if (!obtenerValor(state?.resumen_procedimiento)) errores.push('Resumen del procedimiento requerido');
    // }z 

    // if (tipoFormulario === COD_APRENDER ) {
    //     if (!obtenerValor(state?.dificultades_academicas)) errores.push('Dificultades académicas requeridas');
    // }

    // if (tipoFormulario === COD_COMUNICATE ) {
    //     if (!obtenerValor(state?.habilidades_comunicativas)) errores.push('Habilidades comunicativas requeridas');
    // }

    // if (tipoFormulario === COD_SOCIOEMOCIONAL) {
    //     if (!obtenerValor(state?.sintomas_presentados)) errores.push('Síntomas presentados requeridos');
    // }

    return {
        valido: errores.length === 0,
        errores,
    };
};
